import api from './api';

const emailHistoryService = {
  getHistory: async (params = {}) => {
    const response = await api.get('/email-history', { params });
    return response.data;
  },
  getAccounts: async () => (await api.get('/email-history/accounts')).data,
  createAccount: async (payload) => (await api.post('/email-history/accounts', payload)).data,
  updateAccount: async (id, payload) => (await api.patch(`/email-history/accounts/${id}`, payload)).data,
  testAccount: async (id) => (await api.post(`/email-history/accounts/${id}/test`)).data,
  syncAccount: async (id) => (await api.post(`/email-history/accounts/${id}/sync`)).data,
  getAccountAccess: async (id) => (await api.get(`/email-history/accounts/${id}/access`)).data,
  setAccountAccess: async (id, users) => (await api.put(`/email-history/accounts/${id}/access`, { users })).data,
  getThreads: async (params) => (await api.get('/email-history/threads', { params })).data,
  getFolderCounts: async (accountId) => (await api.get('/email-history/folders/counts', { params: { account_id: accountId } })).data,
  getApprovals: async () => (await api.get('/email-history/approvals')).data,
  getFollowups: async () => (await api.get('/email-history/followups')).data,
  getThread: async (id) => (await api.get(`/email-history/threads/${id}`)).data,
  updateThreadStatus: async (id, status) => (await api.patch(`/email-history/threads/${id}/status`, { status })).data,
  updateThreadFolder: async (id, folder) => (await api.patch(`/email-history/threads/${id}/folder`, { folder })).data,
  linkThread: async (id, payload) => (await api.patch(`/email-history/threads/${id}/link`, payload)).data,
  getMessages: async (params) => (await api.get('/email-history/messages', { params })).data,
  getMessage: async (id) => (await api.get(`/email-history/messages/${id}`)).data,
  getAttachment: async (id, disposition = 'inline') => (await api.get(`/email-history/attachments/${id}`, { params: { disposition }, responseType: 'blob' })).data,
  analyzeMessage: async (id) => (await api.post(`/email-history/messages/${id}/analyze`)).data,
  reviewAnalysis: async (id, payload) => (await api.patch(`/email-history/messages/${id}/analysis`, payload)).data,
  sendNew: async (payload) => {
    const form = new FormData();
    ['account_id', 'to', 'cc', 'bcc', 'subject', 'body', 'html_body', 'client_id', 'project_id'].forEach((field) => {
      if (payload[field] !== undefined && payload[field] !== null) form.append(field, payload[field]);
    });
    (payload.attachments || []).forEach((file) => form.append('attachments', file));
    return (await api.post('/email-history/messages', form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
  reply: async (id, payload) => {
    const form = new FormData();
    form.append('subject', payload.subject || ''); form.append('body', payload.body || '');
    if (payload.html_body) form.append('html_body', payload.html_body);
    if (payload.analysis_version !== undefined) form.append('analysis_version', payload.analysis_version);
    (payload.attachments || []).forEach((file) => form.append('attachments', file));
    return (await api.post(`/email-history/messages/${id}/reply`, form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  }
};

export default emailHistoryService;
